import { useEffect } from 'react';
import type { IUseFormCreationTriggerProps } from '../types';

// This hook is used to trigger the form creation when the form is loaded and the DOM is hydrated
export const useFormCreationTrigger = ({
  isLoaded,
  isHydrated,
  formId,
  elementId,
  formCreated,
  createForm,
}: IUseFormCreationTriggerProps) => {
  useEffect(() => {
    if (isLoaded && isHydrated && elementId && formId && !formCreated.current) {
      formCreated.current = true;
      
      // Add a small delay to ensure DOM is ready
      setTimeout(() => {
        createForm();
      }, 100);
    }
  }, [formId, isLoaded, isHydrated, elementId, createForm, formCreated]);
}; 
